import { apiRequest } from '../../lib/api-client.js';

export interface SuperUser {
  id: number;
  email: string;
  name: string;
}

export type LoginResponse =
  | { status: 'totp_required'; challenge_token: string }
  | { status: 'totp_setup_required'; setup_token: string };

export type AuthenticatedResponse = { status: 'authenticated'; user: SuperUser };

export interface SetupTotpResponse {
  secret: string;
  otpauth_uri: string;
  qr_data_url: string;
}

export async function login(email: string, password: string): Promise<LoginResponse> {
  return apiRequest('/api/auth/login', { method: 'POST', body: { email, password } });
}

export async function loginTotp(
  challengeToken: string,
  code: string,
): Promise<AuthenticatedResponse> {
  return apiRequest('/api/auth/login/totp', {
    method: 'POST',
    body: { challenge_token: challengeToken, code },
  });
}

export async function getSetupTotp(setupToken: string): Promise<SetupTotpResponse> {
  return apiRequest('/api/auth/setup-totp', { bearerToken: setupToken });
}

export async function confirmSetupTotp(
  setupToken: string,
  code: string,
): Promise<AuthenticatedResponse> {
  return apiRequest('/api/auth/setup-totp/confirm', {
    method: 'POST',
    body: { code },
    bearerToken: setupToken,
  });
}

export async function getMe(): Promise<SuperUser> {
  return apiRequest('/api/me', { silent401: true });
}

export async function logout(): Promise<void> {
  await apiRequest('/api/auth/logout', { method: 'POST' });
}
